import ShopType from "@/enum/ShopType";
import getAuthShopUrl from "@/services/getAuthShopUrl";

const TaoBaoShop = {
    [ShopType.TAOBAO]: {
        image: "//img.alicdn.com/imgextra/i4/54458674/O1CN01fOprAy2DwkARNFfGA_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },

    TMALL: {
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01kcxYZk2DwkAVyHKpp_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },

    TAOTE: {
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01Xy81Wh2DwkAdkNssX_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },
    [ShopType.TAOBAO_DISTRIBUTION]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN01ivSIoO2DwkAYZMdC5_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.TAOBAO),
    },
    [ShopType.ALIBABA]: {
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01b9UpYr2DwkANNiBgX_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.ALIBABA),
    },

    [ShopType.ALI_C2M]: {
        image: "//img.alicdn.com/imgextra/i1/54458674/O1CN016giEVW2DwkAPyCaKJ_!!54458674.jpg",
        auth: getAuthShopUrl(ShopType.ALI_C2M),
    },
};

export default TaoBaoShop;
